import $store from '@/store'
import i18n from '@/i18n'
import { find } from 'lodash-es'
import $api from '@/api'
import $router from '@/router'
import { numeralFormatter, computedErrorMsg } from '@/utils/base'
const { Message } = window.ELEMENT

export const clearConfirmData = () => {
  $store.commit('purchase/CLEAR_CONFIRM_DATA')
}

export const ddosDisplayName = (name, ddos) => {
  if (name === 'CS-999') {
    return i18n.t('purchase.fullProtect')
  } else {
    return `${numeralFormatter(ddos)}Gbps`
  }
}

export const ddosMaxDisplayName = (name, val) => {
  if (name === 'CS-999') {
    return i18n.t('packages.unlimitedProtect')
  } else {
    return `${numeralFormatter(val)}Gbps`
  }
}

const findBandwidthRangePrice = (ranges, val) => {
  if (!ranges?.length) return 0
  let result = 0
  for (let i = 0; i < ranges.length; i++) {
    if (val >= ranges[i].minBandwidth && val < ranges[i].maxBandwidth) {
      result = ranges[i].monthPrice
      break
    }
  }
  return result
}

export const feeMonths = sec => {
  const hours = parseInt(sec / 3600)
  return hours / 24 / 30
}

// 新购/续费floodShield套餐价格
export const fsNewRenewOriginalPrice = (packageList, priceList, data, curPkg, productType) => {
  let result = 0
  if (packageList.length && priceList.length && curPkg) {
    const thePrice = find(priceList, { productType })
    const diffBandwidth = data.bandwidth - curPkg?.bandwidth
    const diffBandwidthPrice = findBandwidthRangePrice(thePrice.bandwidthPrices, diffBandwidth)
    result = data.buyTime * (
      curPkg?.price +
      (diffBandwidth * diffBandwidthPrice) +
      (data.port - curPkg?.port) * thePrice.otherPrice?.portPrice +
      (data.website - curPkg?.website) * thePrice.otherPrice?.domainPrice
    )
  }
  return result > 0 ? result : 0
}

// 升级floodShield套餐价格
export const fsUpgradeOriginalPrice = (packageList, priceList, data, curPkg, productType) => {
  let result = 0
  if (packageList.length && priceList.length && curPkg) {
    const thePrice = find(priceList, { productType })
    const diffBandwidth = data.bandwidth - curPkg?.bandwidth
    const diffBandwidthPrice = findBandwidthRangePrice(thePrice.bandwidthPrices, diffBandwidth)
    const diffPort = data.port - curPkg?.port
    const diffWebsite = data.website - curPkg?.website
    result = feeMonths(data.remainTime) * (
            diffBandwidth * diffBandwidthPrice +
            diffPort * thePrice.otherPrice?.portPrice +
            diffWebsite * thePrice.otherPrice?.domainPrice +
            curPkg.price -
            (data.price / data.buyTime)
          )
  }
  return result > 0 ? result : 0
}

export const generateOrder = async params => {
  const res = await $api['purchase/orderSubmit'](params)
  if (res?.code === 200) {
    if (res.data?.status === 2) {
      // 已支付订单
      if (res.data?.orderIds) {
        $router.push({
          path: '/purchase/pay/success',
          query: {
            orderId: res.data.orderIds.join(',')
          }
        })
      } else {
        Message.error('接口未返回正确的订单号')
      }
    } else {
      // 去支付页面
      if (res.data?.orderIds) {
        $router.push({
          path: '/purchase/pay',
          query: {
            orderIds: res.data.orderIds.join(',')
          }
        })
      } else {
        Message.error('接口未返回正确的订单号')
      }
    }
  } else if (res?.code === 302) {
    // 已存在订单，去订单详情页
    if (res.data) {
      $router.push({
        path: '/orders/orderDetail',
        query: { orderId: res.data }
      })
    } else {
      Message.error('接口未返回正确的订单号')
    }
  } else {
    Message.error(computedErrorMsg(res))
  }
}

export const paypalSubmit = orderIds => {
  return new Promise(resolve => {
    $api['purchase/paypalPay']({ orderIds }).then(res => {
      if (res?.code === 200) {
        window.open(res.data, '_blank')
      }
    }).finally(() => resolve())
  })
}

export const stripeSubmit = (orderIds, target = '_blank') => {
  return new Promise(resolve => {
    $api['purchase/stripePay']({ orderIds }).then(res => {
      if (res?.code === 200) {
        window.open(res.data, target)
      }
    }).finally(() => resolve())
  })
}

export const tripleASubmit = (orderIds, target = '_blank') => {
  return new Promise(resolve => {
    $api['purchase/tripleAPay']({ orderIds }).then(res => {
      if (res?.code === 200) {
        window.open(res.data, target)
      }
    }).finally(() => resolve())
  })
}

export const trafficMap = val => {
  if (!val || val.length < 2) {
    return {
      value: 0,
      unit: 'GB'
    }
  }
  const unit = val.slice(-2)
  const valueStr = val.slice(0, -2)
  return {
    value: isNaN(valueStr) ? 0 : valueStr * 1,
    unit
  }
}
